import {
  Defaults,
  Traits
} from './shared';

import { ICON_BUTTON_PERIODISATION_CALENDAR } from './../../../const/icons';

import { COMP_BUTTON_PERIODISATION_CALENDAR } from './../../../const/components';

import { FIELD_PERIODISATION_CALENDAR_SELECTOR } from './../../../const/traits';

import { PageFormLinkedItem } from './../page-form-linked-item';

export const PeriodisationCalendar = (editor, options:any = {}) => {

  (FIELD_PERIODISATION_CALENDAR_SELECTOR as any).at = 9;

  return PageFormLinkedItem(editor, {
    componentName: COMP_BUTTON_PERIODISATION_CALENDAR,
    displayIcon: ICON_BUTTON_PERIODISATION_CALENDAR,
    model: {
      defaults: { ...Defaults,
        name: 'Periodisation Calendar',
        traits: [ ...Traits, FIELD_PERIODISATION_CALENDAR_SELECTOR]
      }
    }
  });
}